import React from "react";

interface BarChartItemProps {
  name: string;
  clicks: number;
  color: string;
}

interface BarChartProps {
  items: BarChartItemProps[];
  title?: string;
}

const BarChart: React.FC<BarChartProps> = ({ items, title }) => {
  const maxClicks = Math.max(...items.map((item) => item.clicks));

  return (
    <>
      <div className="mb-4 mt-4">
        <div className="grid grid-cols-2 gap-2 mb-6 mt-5">
          {items.map((item, index) => (
            <div key={index} className="flex items-center gap-2">
              <div className={`w-[12px] h-[12px] rounded-full ${item.color}`} />
              <span className="text-[12px] nunito-regular text-[#404040]">
                {item.name}
              </span>
            </div>
          ))}
        </div>{" "}
      </div>
      {title && (
        <div className="mb-3">
          <h3 className="text-[20px] nunito-regular text-[#0A0A0A]">{title}</h3>
        </div>
      )}
      <div className="border-b border-[1.07px] mb-2 border-[#EBEBEB]"></div>

      {/* Bars */}
      <div className="space-y-9 max-w-full">
        {items.map((item, index) => (
          <div key={index} className="relative h-[9px]">
            <div
              className={`absolute h-full ${item.color} rounded-l-none rounded-full transition-all duration-300`}
              style={{
                width: `${(item.clicks / maxClicks) * 80}%`,
              }}
            >
              <span className="absolute right-[-26px] top-1/2 -translate-y-1/2 text-sm text-[#404040]">
                {item.clicks}
              </span>
            </div>
          </div>
        ))}
      </div>
      <div className="border-b border-[1.07px] mt-4 border-[#EBEBEB]"></div>
    </>
  );
};

export default BarChart;
